import { _s } from '@/locale';
import { AccountNavItem, AccountNavItemIdentifier } from './AccountNavigation.types';

const baseTranslationKey = 'features.account-navigation.constants';

const PROFILE_NAV_ITEM: AccountNavItem = {
  identifier: AccountNavItemIdentifier.Profile,
  label: _s(`${baseTranslationKey}.PROFILE_NAV_ITEM.label`),
  icon: 'contact-card',
  to: '/my-profile',
};

const FAVORITES_NAV_ITEM: AccountNavItem = {
  identifier: AccountNavItemIdentifier.Favorites,
  label: _s(`${baseTranslationKey}.FAVORITES_NAV_ITEM.label`),
  icon: 'heart',
  to: '/favoriter',
};

const BOOKINGS_NAV_ITEM: AccountNavItem = {
  identifier: AccountNavItemIdentifier.Bookings,
  label: _s(`${baseTranslationKey}.BOOKINGS_NAV_ITEM.label`),
  icon: 'calendar-user',
  to: '/bokningar',
};

const PAYMENT_METHODS_NAV_ITEM: AccountNavItem = {
  identifier: AccountNavItemIdentifier.PaymentMethods,
  label: _s(`${baseTranslationKey}.PAYMENT_METHODS_NAV_ITEM.label`),
  icon: 'credit-card',
  to: '/betalningsmetoder',
};

const BUNDLES_NAV_ITEM: AccountNavItem = {
  identifier: AccountNavItemIdentifier.Bundles,
  label: _s(`${baseTranslationKey}.BUNDLES_NAV_ITEM.label`),
  icon: 'punch-card',
  to: '/klippkort/giltig',
};

export const ACCOUNT_NAV_ITEMS = [
  PROFILE_NAV_ITEM,
  FAVORITES_NAV_ITEM,
  BOOKINGS_NAV_ITEM,
  PAYMENT_METHODS_NAV_ITEM,
  BUNDLES_NAV_ITEM,
];
